export function buildSoftwareApplicationSchema({ siteUrl, siteName }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: siteName,
    applicationCategory: 'CommunicationApplication',
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'EUR',
      availability: 'https://schema.org/InStock',
      url: `${siteUrl}/#contact`,
    },
    operatingSystem: 'Web Browser, Windows, MacOS, Linux, iOS, Android',
    description:
      'Infrastructures vidéo métier WebRTC intégrables : assistance client, rendez-vous, live, API vidéo, hébergement France ou on-premise et parcours vidéo sur mesure.',
    featureList: [
      'Infrastructure WebRTC temps réel',
      'Architecture SFU scalable',
      'Serveurs STUN/TURN documentés pour entreprise',
      'API vidéo et intégration navigateur',
      'Hébergement France ou on-premise',
      'Démarche alignée RGPD',
      'Composants open source',
      'Faible latence et qualité adaptative',
      'Vidéo embarquée (iframe, SDK)',
    ],
    screenshot: `${siteUrl}/screenshot.png`,
    softwareVersion: '2.0',
  };
}
